import Vue from 'vue'

const months = ['January', 'February', 'March', 'April', 'May', 'June', ' July', 'August', 'September', 'October', 'November', 'December']
// type为1：，2：20181222
//formate：YYYYMMDD,MMDD
Vue.filter('formateDate', function (ms, type, formate) {
  if (!ms) {
    return ''
  }
  type = type ? type : 1
  formate = formate ? formate : 'YYYYMD'
  let date, y, m, d
  switch (type) {
    case 2:
      y = ms.substring(0, 4)
      m = ms.substring(4, 6)
      d = ms.substring(6, 8)
      if (m.slice(0, 1) === '0') {
        m = m.slice(1)
      }
      if (d.slice(0, 1) === '0') {
        d = d.slice(1)
      }
      break
    default:
      date = new Date(ms)
      y = date.getFullYear()
      m = 1 + date.getMonth()
      d = date.getDate()
  }
  if (window.localStorage.getItem('lang') === 'en') {
    if (formate === 'MD') {
      return d + ' ' + months[m - 1]
    }
    return d + ' ' + months[m - 1] + ',' + y
  } else {
    if (formate === 'MD') {
      return m + '月' + d + '日'
    }
    return y + '年' + m + '月' + d + '日'
  }
})


// WEBPACK FOOTER //
// ./src/filter/index.js